export const radii = {
  m: '4px',
  ml: '8px',
  l: '16px',
  round: '100%',
  pill: '100vh',
};
